// 统一导出所有指令模块
import type { App, Directive } from 'vue'
import exposure from './exposure'

const directives: Record<string, Directive> = {
    exposure,
}

export default {
    install: (app: App) => {
        Object.entries(directives).forEach(([key, directive]) => {
            app.directive(key, directive)
        })
    }
}

export { exposure }